/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UploadedFileResponseDto } from './UploadedFileResponseDto';
import {
    UploadedFileResponseDtoFromJSON,
    UploadedFileResponseDtoFromJSONTyped,
    UploadedFileResponseDtoToJSON,
    UploadedFileResponseDtoToJSONTyped,
} from './UploadedFileResponseDto';

/**
 * 
 * @export
 * @interface BinderResponseDto
 */
export interface BinderResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof BinderResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BinderResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    binderId: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    binderName: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    binderLongName: string;
    /**
     * 
     * @type {Date}
     * @memberof BinderResponseDto
     */
    authorityStartDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof BinderResponseDto
     */
    authorityEndDate: Date;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    currency: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    primaryMaxLimit: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    qsEolMaxLimit: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BinderResponseDto
     */
    territories: Array<BinderResponseDtoTerritoriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BinderResponseDto
     */
    markets: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof BinderResponseDto
     */
    lineOfBusinesses: Array<BinderResponseDtoLineOfBusinessesEnum>;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    placeBroker: BinderResponseDtoPlaceBrokerEnum;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    placementBrokerCommission: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    pinCommission: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    security: BinderResponseDtoSecurityEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof BinderResponseDto
     */
    excludedPrincipalOccupations?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    binderGroup: BinderResponseDtoBinderGroupEnum;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    claimsReferralAmount: string;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    defaultFloatBankAccount?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BinderResponseDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    comment?: string;
    /**
     * 
     * @type {number}
     * @memberof BinderResponseDto
     */
    underwritingYear: number;
    /**
     * 
     * @type {string}
     * @memberof BinderResponseDto
     */
    status: BinderResponseDtoStatusEnum;
    /**
     * 
     * @type {Array<UploadedFileResponseDto>}
     * @memberof BinderResponseDto
     */
    files?: Array<UploadedFileResponseDto>;
}


/**
 * @export
 */
export const BinderResponseDtoTerritoriesEnum = {
    Africa: 'Africa',
    Anz: 'ANZ',
    Asia: 'Asia',
    Europe: 'Europe',
    MiddleEast: 'Middle East',
    NorthAmerica: 'North America',
    Pacific: 'Pacific',
    SouthAmerica: 'South America'
} as const;
export type BinderResponseDtoTerritoriesEnum = typeof BinderResponseDtoTerritoriesEnum[keyof typeof BinderResponseDtoTerritoriesEnum];

/**
 * @export
 */
export const BinderResponseDtoLineOfBusinessesEnum = {
    Property: 'Property',
    Power: 'Power',
    OnshoreEnergy: 'Onshore Energy',
    CrisisManagement: 'Crisis Management',
    Casualty: 'Casualty',
    ProfessionalLines: 'Professional Lines'
} as const;
export type BinderResponseDtoLineOfBusinessesEnum = typeof BinderResponseDtoLineOfBusinessesEnum[keyof typeof BinderResponseDtoLineOfBusinessesEnum];

/**
 * @export
 */
export const BinderResponseDtoPlaceBrokerEnum = {
    Aon: 'AON',
    GcAccess: 'GC Access',
    LkRe: 'LK Re'
} as const;
export type BinderResponseDtoPlaceBrokerEnum = typeof BinderResponseDtoPlaceBrokerEnum[keyof typeof BinderResponseDtoPlaceBrokerEnum];

/**
 * @export
 */
export const BinderResponseDtoSecurityEnum = {
    SpA: 'S&P A-',
    SpA2: 'S&P A',
    SpA3: 'S&P A+',
    AmBestA: 'AM Best A-',
    AmBestA2: 'AM Best A',
    AmBestA3: 'AM Best A+'
} as const;
export type BinderResponseDtoSecurityEnum = typeof BinderResponseDtoSecurityEnum[keyof typeof BinderResponseDtoSecurityEnum];

/**
 * @export
 */
export const BinderResponseDtoBinderGroupEnum = {
    AmFirst: 'AM First',
    ArchReEurope: 'Arch Re Europe',
    AsiaInsurance: 'Asia Insurance',
    AstraBuana: 'Astra Buana',
    Bmiic: 'BMIIC',
    Bocgi: 'BOCGI',
    MalRe: 'MAL RE',
    SamsungRe: 'Samsung Re'
} as const;
export type BinderResponseDtoBinderGroupEnum = typeof BinderResponseDtoBinderGroupEnum[keyof typeof BinderResponseDtoBinderGroupEnum];

/**
 * @export
 */
export const BinderResponseDtoStatusEnum = {
    Active: 'Active',
    Upcoming: 'Upcoming',
    Expired: 'Expired'
} as const;
export type BinderResponseDtoStatusEnum = typeof BinderResponseDtoStatusEnum[keyof typeof BinderResponseDtoStatusEnum];


/**
 * Check if a given object implements the BinderResponseDto interface.
 */
export function instanceOfBinderResponseDto(value: object): value is BinderResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('binderId' in value) || value['binderId'] === undefined) return false;
    if (!('binderName' in value) || value['binderName'] === undefined) return false;
    if (!('binderLongName' in value) || value['binderLongName'] === undefined) return false;
    if (!('authorityStartDate' in value) || value['authorityStartDate'] === undefined) return false;
    if (!('authorityEndDate' in value) || value['authorityEndDate'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    if (!('primaryMaxLimit' in value) || value['primaryMaxLimit'] === undefined) return false;
    if (!('qsEolMaxLimit' in value) || value['qsEolMaxLimit'] === undefined) return false;
    if (!('territories' in value) || value['territories'] === undefined) return false;
    if (!('markets' in value) || value['markets'] === undefined) return false;
    if (!('lineOfBusinesses' in value) || value['lineOfBusinesses'] === undefined) return false;
    if (!('placeBroker' in value) || value['placeBroker'] === undefined) return false;
    if (!('placementBrokerCommission' in value) || value['placementBrokerCommission'] === undefined) return false;
    if (!('pinCommission' in value) || value['pinCommission'] === undefined) return false;
    if (!('security' in value) || value['security'] === undefined) return false;
    if (!('binderGroup' in value) || value['binderGroup'] === undefined) return false;
    if (!('claimsReferralAmount' in value) || value['claimsReferralAmount'] === undefined) return false;
    if (!('underwritingYear' in value) || value['underwritingYear'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function BinderResponseDtoFromJSON(json: any): BinderResponseDto {
    return BinderResponseDtoFromJSONTyped(json, false);
}

export function BinderResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BinderResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'binderId': json['binderId'],
        'binderName': json['binderName'],
        'binderLongName': json['binderLongName'],
        'authorityStartDate': (new Date(json['authorityStartDate'])),
        'authorityEndDate': (new Date(json['authorityEndDate'])),
        'currency': json['currency'],
        'primaryMaxLimit': json['primaryMaxLimit'],
        'qsEolMaxLimit': json['qsEolMaxLimit'],
        'territories': json['territories'],
        'markets': json['markets'],
        'lineOfBusinesses': json['lineOfBusinesses'],
        'placeBroker': json['placeBroker'],
        'placementBrokerCommission': json['placementBrokerCommission'],
        'pinCommission': json['pinCommission'],
        'security': json['security'],
        'excludedPrincipalOccupations': json['excludedPrincipalOccupations'] == null ? undefined : json['excludedPrincipalOccupations'],
        'binderGroup': json['binderGroup'],
        'claimsReferralAmount': json['claimsReferralAmount'],
        'defaultFloatBankAccount': json['defaultFloatBankAccount'] == null ? undefined : json['defaultFloatBankAccount'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'underwritingYear': json['underwritingYear'],
        'status': json['status'],
        'files': json['files'] == null ? undefined : ((json['files'] as Array<any>).map(UploadedFileResponseDtoFromJSON)),
    };
}

export function BinderResponseDtoToJSON(json: any): BinderResponseDto {
    return BinderResponseDtoToJSONTyped(json, false);
}

export function BinderResponseDtoToJSONTyped(value?: BinderResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'binderId': value['binderId'],
        'binderName': value['binderName'],
        'binderLongName': value['binderLongName'],
        'authorityStartDate': ((value['authorityStartDate']).toISOString()),
        'authorityEndDate': ((value['authorityEndDate']).toISOString()),
        'currency': value['currency'],
        'primaryMaxLimit': value['primaryMaxLimit'],
        'qsEolMaxLimit': value['qsEolMaxLimit'],
        'territories': value['territories'],
        'markets': value['markets'],
        'lineOfBusinesses': value['lineOfBusinesses'],
        'placeBroker': value['placeBroker'],
        'placementBrokerCommission': value['placementBrokerCommission'],
        'pinCommission': value['pinCommission'],
        'security': value['security'],
        'excludedPrincipalOccupations': value['excludedPrincipalOccupations'],
        'binderGroup': value['binderGroup'],
        'claimsReferralAmount': value['claimsReferralAmount'],
        'defaultFloatBankAccount': value['defaultFloatBankAccount'],
        'fileIds': value['fileIds'],
        'comment': value['comment'],
        'underwritingYear': value['underwritingYear'],
        'status': value['status'],
        'files': value['files'] == null ? undefined : ((value['files'] as Array<any>).map(UploadedFileResponseDtoToJSON)),
    };
}

